import React, { useEffect, useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { useParams } from 'react-router-dom';
import { axiosPath } from '../../../routing/helpers/router';
import * as moduleAction from '../../../store/actions/moduleAction';

const ModuleLoader = () => {
  const dispatch = useDispatch();
  const { moduleBridgeHex } = useParams();

  const moduleLoad = useCallback(async () => {
    try {
      await dispatch(moduleAction.getModulePayload(axiosPath('api_r_user_global_getModulePayload'), moduleBridgeHex));
    } catch (err) {}
  }, [moduleBridgeHex]);

  useEffect(() => {
    moduleLoad();
  }, [moduleBridgeHex]);

  return (
    <></>
  );
};

export default ModuleLoader;
